// Environment configuration constants
export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL,
    ENDPOINTS: {
        SEARCH_CONTACTS: '/api/searchGhlContacts',
        WEBCALL_BNUMS: '/api/getWebCallingBnums',
        SMS_BNUMS: '/api/listValidSmsBnums',
        MANAGE_GHL_USERS: '/api/manageGhlUsers',
        GET_USER_DATA: '/decrypt-sso',
    },
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
};

export const WEBRTC_CONFIG = {
    WEBSOCKET_BASE_URL:
        process.env.REACT_APP_WEBSOCKET_BASE_URL ||
        'wss://webrtc-{country}.avanser.cloud:8089/ws',
    SIP_BASE_URL:
        process.env.REACT_APP_SIP_BASE_URL || 'webrtc-{country}.avanser.cloud',
    STUN_SERVERS: [
        {
            urls:
                process.env.REACT_APP_STUN_SERVER_1 ||
                'stun:stun.l.google.com:19302',
        },
        {
            urls:
                process.env.REACT_APP_STUN_SERVER_2 ||
                'stun:stun1.l.google.com:19302',
        },
        {
            urls:
                process.env.REACT_APP_STUN_SERVER_3 ||
                'stun:stun2.l.google.com:19302',
        },
    ],
    ICE_GATHERING_TIMEOUT:
        parseInt(process.env.REACT_APP_ICE_GATHERING_TIMEOUT) || 5000,
    USER_AGENT_TIMEOUT:
        parseInt(process.env.REACT_APP_USER_AGENT_TIMEOUT) || 10000,
    ENABLE_SIP_TRACE: process.env.REACT_APP_ENABLE_SIP_TRACE === 'true',
};

export const APP_CONFIG = {
    DEFAULT_COUNTRY: process.env.REACT_APP_DEFAULT_COUNTRY || 'au',
    SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL || 'support@avanser.com',
    LOG_LEVEL: process.env.REACT_APP_LOG_LEVEL || 'info',
};

export const COUNTRY_CONFIG = Object.freeze({
    au: {
        name: 'Australia',
        dialCode: '+61',
        dialCodeWithoutPlus: '61',
        // Australian mobile numbers start with 04, 05, 07, or 08
        // Australian landline numbers start with 02, 03, 07, or 08
        validPatterns: [
            /^04\d{8}$/, // Mobile: 04xx xxx xxx
            /^05\d{8}$/, // Mobile: 05xx xxx xxx
            /^07\d{8}$/, // Mobile/Landline: 07xx xxx xxx
            /^08\d{8}$/, // Mobile/Landline: 08xx xxx xxx
            /^02\d{8}$/, // Landline: 02xx xxx xxx
            /^03\d{8}$/, // Landline: 03xx xxx xxx
        ],
    },
    nz: {
        name: 'New Zealand',
        dialCode: '+64',
        dialCodeWithoutPlus: '64',
        // New Zealand mobile numbers start with 02
        // Landline numbers start with 03, 04, 06, 07, 09
        validPatterns: [
            /^02\d{7,9}$/, // Mobile: 02xx xxx xxxx (various lengths)
            /^03\d{7}$/, // Landline: 03xx xxx xxx
            /^04\d{7}$/, // Landline: 04xx xxx xxx
            /^06\d{7}$/, // Landline: 06xx xxx xxx
            /^07\d{7}$/, // Landline: 07xx xxx xxx
            /^09\d{7}$/, // Landline: 09xx xxx xxx
        ],
    },
    my: {
        name: 'Malaysia',
        dialCode: '+60',
        dialCodeWithoutPlus: '60',
        // Malaysian mobile numbers start with 01
        // Landline numbers start with 03, 04, 05, 06, 08, 09
        validPatterns: [
            /^01\d{8,9}$/, // Mobile: 01xx xxx xxx (various lengths)
            /^03\d{7,8}$/, // Landline: 03xx xxx xxx (various lengths)
            /^04\d{7,8}$/, // Landline: 04xx xxx xxx (various lengths)
            /^05\d{7,8}$/, // Landline: 05xx xxx xxx (various lengths)
            /^06\d{7,8}$/, // Landline: 06xx xxx xxx (various lengths)
            /^08\d{7,8}$/, // Landline: 08xx xxx xxx (various lengths)
            /^09\d{7,8}$/, // Landline: 09xx xxx xxx (various lengths)
        ],
    },
});
